import client from "./client";

const endpoint = "flight-schedules";

const getFlightSchedules = () => client.get(endpoint);

export default getFlightSchedules;
